// extracted by mini-css-extract-plugin
export default {"icon":"Product_icon__wlywt","container":"Product_container__Nv8y2","cardProduct":"Product_cardProduct__uj7Uk","break":"Product_break__XEx-o"};